exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".point-lottery-container .overflow-on .cell[data-v-520c11b8]{overflow:visible;overflow-x:visible;overflow-y:visible}.point-lottery-container .el-table__row button[data-v-520c11b8]{margin:5px}.point-lottery-container .prize-table[data-v-520c11b8] td{padding:4px 0}.point-lottery-container .activity-rules[data-v-520c11b8]{max-width:280px;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;text-overflow:ellipsis;white-space:pre-wrap}.point-lottery-container .share-text[data-v-520c11b8]{max-width:280px;white-space:pre-wrap;overflow:hidden;text-overflow:ellipsis}\n", ""]);

// exports
